import { ArrowRight } from 'lucide-react';
import './Cta.scss';
import { Link } from 'react-router-dom';

const Cta = () => {
  return (
    <section className="cta">
      <div className="cta-container">
        <div className="cta-content">
          <h2>Start Trading Like a Pro Today</h2>
          <p>
            Join thousands of successful traders who have transformed their trading with FNOTrader
          </p>
          <div className="buttons">
            <Link to="/pricing" className="button primary">
              <span>Start Free Trial</span>
              <ArrowRight className="icon" />
            </Link>
            <Link to="/contact-us" className="button secondary">
              Schedule Demo
              <svg className="icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  strokeWidth="2" 
                  d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
                />
              </svg>
            </Link>
          </div>
        </div>

        <div className="disclaimer">
          <p>
            Risk Disclaimer: Trading Futures &amp; Options involves substantial risk of loss and is not suitable for all investors. 
            Please ensure you fully understand the risks involved before trading.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Cta;